import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "./shared/controls/Modal";
import { getTenantVerification } from "../services/tenantVerification";
import "./TenantVerificationPrompt.css";

export default function TenantVerificationPrompt({ transactionId }: { transactionId: string }) {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!transactionId) return;
    const controller = new AbortController();
    let timer: ReturnType<typeof setTimeout> | undefined;
    const enteredAt = Date.now();
    getTenantVerification(controller.signal)
      .then((verification) => {
        if (controller.signal.aborted || !(verification?.status === "rejected" || verification == null || (typeof verification === "object" && Object.keys(verification).length === 0))) return;
        timer = setTimeout(() => setShow(true), Math.max(0, 2000 - (Date.now() - enteredAt)));
      })
      .catch(() => {
        // A failed check is not evidence that verification is inactive.
      });
    return () => {
      controller.abort();
      clearTimeout(timer);
    };
  }, [transactionId]);

  return (
    <Modal show={show} onClose={() => setShow(false)} size={620} className="tenant-verification-prompt">
      <div className="tenant-verification-prompt__body font-onest">
        <div className="tenant-verification-prompt__icon" aria-hidden="true">🎉</div>
        <h3>One last step to lock in your stay!</h3>
        <p>Complete your Tenancy Verification to finalize your rent agreement. Completing this now prevents any landlord approval delays.</p>
        <button type="button" className="btn" onClick={() => {
          setShow(false);
          navigate(`/settings?tab=tenant-verification&transaction=${encodeURIComponent(transactionId)}`);
        }}>Proceed to Tenant Verification</button>
      </div>
    </Modal>
  );
}
